import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import heroImage from '../assets/images/hero-dessert.png';
import MarketDates from '../components/MarketDates';
import { getUpcomingMarketDates } from '../config/marketDates';
import './HeroSection.css';

const HeroSection = () => {
  const hasMarketDates = getUpcomingMarketDates().length > 0;

  return (
    <div className="home-page-container">
      <section className="hero-section">
      {/* Background Elements */}
      <div className="hero-background">
        <div className="background-shape shape-1"></div>
        <div className="background-shape shape-2"></div>
        <div className="background-shape shape-3"></div>
      </div>

      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-badge">
              <span className="badge-text">✨ Authentic Venezuelan Desserts</span>
            </div>
            
            <h1 className="hero-title">
              <span className="title-line">Sweet Moments</span>
              <span className="title-line title-accent">Made Perfect</span>
            </h1>
            
            <p className="hero-description">
              Experience the authentic taste of Venezuela with our signature Tres Leches cake 
              and handcrafted desserts. Made fresh with love in our home bakery.
            </p>

            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-number">100%</span>
                <span className="stat-label">Fresh Handmade</span>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <span className="stat-number">★★★★★</span>
                <span className="stat-label">Customer Love</span>
              </div>
            </div>

            <div className="hero-actions">
              <Link to="/menu">
                <Button variant="primary" size="large" className="hero-cta">
                  <span>Explore Menu</span>
                  <svg className="button-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Button>
              </Link>
              
              <Link to="/about" className="hero-secondary-link">
                <span>Our Story</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
              
              {hasMarketDates && (
                <a href="#market-dates" className="hero-secondary-link" onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('market-dates').scrollIntoView({ behavior: 'smooth' });
                }}>
                  <span>Find us at Markets</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 5V19M12 19L5 12M12 19L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              )}
            </div>
          </div>

          <div className="hero-visual">
            <div className="hero-image-container">
              <img src={heroImage} alt="Panela Crumbs Desserts" className="hero-image" />

              <div className="floating-elements">
                <div className="floating-card card-1">
                  <div className="card-icon">🍰</div>
                  <div className="card-text">
                    <span className="card-title">Tres Leches</span>
                    <span className="card-subtitle">Our Signature</span>
                  </div>
                </div>

                <div className="floating-card card-2">
                  <div className="card-icon">♥️</div>
                  <div className="card-text">
                    <span className="card-title">Made with Love</span>
                    <span className="card-subtitle">Every Day</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </section>
      
      <MarketDates />
    </div>
  );
};

export default HeroSection; 